import { atom, atomFamily } from "recoil";

import { RidesViewTypeEnum } from "../../enums";
import {
  IResolveRejectDropdownEditModal,
  IResolveRejectEditModal,
  RydeUiUnit,
} from "../../models";

export const pageEntityAtom = atom<RydeUiUnit>({
  key: "pageEntityAtom",
  default: "unknown",
});

export const mobileSettingsSearchAtom = atom<string>({
  key: "mobileSettingsSearchAtom",
  default: "",
});

export const drawerManageColumnsSearchAtom = atom<string>({
  key: "drawerManageColumnsSearchAtom",
  default: "",
});

export const modalOpenStateAtom = atom<boolean>({
  key: "modalOpenStateAtom",
  default: false,
});

export const profileModalOpenStateAtom = atom<boolean>({
  key: "profileModalOpenStateAtom",
  default: false,
});

export const settingsDrawerOpenStateAtom = atom<boolean>({
  key: "settingsDrawerOpenStateAtom",
  default: false,
});

export const dropdownItemAddDrawerAtom =
  atom<IResolveRejectDropdownEditModal | null>({
    key: "dropdownItemAddDrawerAtom",
    default: null,
  });

export const bulkEditDrawerAtom = atom<IResolveRejectEditModal | null>({
  key: "bulkEditDrawerAtom",
  default: null,
});

export const mapOpenAF = atomFamily<boolean, RidesViewTypeEnum>({
  key: "mapOpenAF",
  default: (view: RidesViewTypeEnum) => view === RidesViewTypeEnum.LiveMap,
});

export const passengerGridMapOpenAtom = atom<boolean>({
  key: "passengerGridMapOpenAtom",
  default: false,
});

export const stationsGridMapOpenAtom = atom<boolean>({
  key: "stationsGridMapOpenAtom",
  default: false,
});

export const areasGridMapOpenAtom = atom<boolean>({
  key: "areasGridMapOpenAtom",
  default: false,
});

export const isInnerItemEditingAtom = atom<boolean>({
  key: "isInnerItemEditingAtom",
  default: false,
});
